"use client";

import { Typography } from "@/components/ui/typography";
import { securityConfidentialCards } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import { GroupedSecurityCardsCarousel } from "@/components/screen/global-components/security";

const SecurityConfidential = ({
  className,
}: React.ComponentProps<"section">) => {
  return (
    <section
      className={cn(
        "section overflow-hidden bg-neutral-50 lg:bg-background-secondary",
        className
      )}
    >
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col justify-center gap-2">
          <Typography variant="heading4" className="md:text-center">
            <h2>How we prioritize privacy and confidentiality</h2>
          </Typography>
          <div className="flex md:justify-center text-gray-600 md:max-w-[780px] md:mx-auto">
            <Typography
              variant="subHeadingSm"
              className="md:text-center"
              asChild
            >
              <p>
                Your trust is our top priority. At Languex, we understand that
                every document you share with us is entrusted with the
                expectation of confidentiality, care, and accuracy. That’s why
                we’ve built a translation company and platform that puts trust
                and data security at the center of every interaction.
              </p>
            </Typography>
          </div>
        </div>
        <GroupedSecurityCardsCarousel
          cards={securityConfidentialCards}
          className="mt-6 md:mt-12"
        />
      </div>
    </section>
  );
};

export default memo(SecurityConfidential);
